import { isAdminAssistantRole } from './dentistSubmissionWizard';

/**
 * Dossier modifiable pendant la phase de soumission (G1/P1) :
 * cas non soumis / terminé et phase encore en cours (ou brouillon).
 */

function getSubmissionPhaseG1(timelinePhaseItems = []) {
  return (
    timelinePhaseItems.find(
      (p) => String(p.group ?? '') === '1' && p.phase_order === 1
    ) ?? null
  );
}

export function isCaseEditableDuringSubmission({ caseData, timelinePhaseItems = [] }) {
  const submissionPhaseG1 = getSubmissionPhaseG1(timelinePhaseItems);

  return (
    !['submitted', 'completed'].includes(caseData?.status) &&
    (caseData?.status === 'draft' || submissionPhaseG1?.status === 'in_progress')
  );
}

function canActAsSubmissionEditor({ userRole, userRoleTypes = [] }) {
  const roles = userRoleTypes?.length ? userRoleTypes : userRole ? [userRole] : [];
  return (
    userRole === 'dentist_client' ||
    roles.includes('dentist_client') ||
    isAdminAssistantRole(roles)
  );
}

export function canEditPrescriptionDuringSubmission({
  userRole,
  userRoleTypes = [],
  caseData,
  timelinePhaseItems = [],
}) {
  return (
    canActAsSubmissionEditor({ userRole, userRoleTypes }) &&
    isCaseEditableDuringSubmission({ caseData, timelinePhaseItems })
  );
}

/** Ajout / suppression de fichiers (photos, scans via modale) pendant la soumission. */
export function canModifyCaseFilesDuringSubmission({
  userRole,
  userRoleTypes = [],
  caseData,
  timelinePhaseItems = [],
}) {
  return (
    canActAsSubmissionEditor({ userRole, userRoleTypes }) &&
    isCaseEditableDuringSubmission({ caseData, timelinePhaseItems })
  );
}
